
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/allshows/[[...all]]",
      function () {
        return require("private-next-pages/allshows/[[...all]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/allshows/[[...all]]"])
      });
    }
  